import {
    GET_USER_START,
    GET_USER_SUCCESS,
    GET_USER__FILED,
} from "../action-types/actionTypes";
import { api } from '../../api/service'



export const getUserCreate = data => {
    return async dispatch => {
        dispatch({
            type: GET_USER_START,
        });
        try {
            const response = await api.post('/getUser', data);
        
            dispatch({
                type: GET_USER_SUCCESS,
                payload: response.data
            });
        } catch (e) {
            dispatch({
                type: GET_USER__FILED,
                error: { message: "Something went wrong." }
            });
        }
    };
}